import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getTipSettings,
  saveTipSettings,
  TIP_SETTINGS_QUERY_KEY,
  type TipSettings,
  type TipSettingsSaveIn,
} from "../api/tipSettings";

/** Кратко: модалът „Закрий" и без това тегли свежи настройки при бакшиш > 0. */
const TIP_SETTINGS_STALE_MS = 60_000;

/**
 * Настройките за бакшиш (`GET /payment-methods/tip-settings`) — чете ги
 * всеки влязъл (сервитьорът в „Закрий", админът в Конфигурация).
 * `data === null` — сървърът не ги поддържа (404) ⇒ бакшиш няма;
 * провалено четене също значи „няма бакшиш" за модала.
 */
export const useTipSettings = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: TIP_SETTINGS_QUERY_KEY,
    queryFn: getTipSettings,
    staleTime: TIP_SETTINGS_STALE_MS,
    enabled: options?.enabled ?? true,
  });

/** Свежо четене извън render-а (проверката при „Закриване"). */
export const fetchFreshTipSettingsQuery = {
  queryKey: TIP_SETTINGS_QUERY_KEY,
  queryFn: getTipSettings,
  staleTime: 0,
} as const;

/** „Запази" в Конфигурация → Видове плащания → Бакшиш. */
export const useSaveTipSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: TipSettingsSaveIn) => saveTipSettings(data),
    onSuccess: (saved: TipSettings) => {
      queryClient.setQueryData(TIP_SETTINGS_QUERY_KEY, saved);
    },
  });
};
